const Suggestion = require('./suggestion');
const SuccessRate = require('../success-rate');
const Job = require('../../../lib/util/job');
const Pruner = Job('./prune.js');
const Tracker = require('../../navigation/tracker');

const tracker = new Tracker();

const template = /* xml */ `<db:pruningtips>
<h3>Optimization Suggestions (beta)</h3>
<p data-id='status' data-ignore='1'>
	Waiting for data.
</p>
<div data-id='result'>
	<div class='table'>
		<div class='thead'>
			<div>
				<div>Card Change</div>
				<div></div>
				<div><span class='lockable'>
					<input type='checkbox' data-id='selectAll' checked />
				</span></div>
			</div>
		</div>
		<div data-id='suggestions' data-collection='db:suggestion'>
		</div>
	</div>
	<p class='lockable'>Apply changes to:
		<button data-id='applyChanges'>This Deck</button> 
		<button data-id='createNew'>New Deck</button>
	</p>
</div>
</db:pruningtips>`;

module.exports = DomClass(template, function() {
	var _t = this;

	this.changeApplicator = null;

	const deckDelta = (from_deck, to_deck) => {
		var from_deck_index = {};
		from_deck.forEach(function(card) {
			from_deck_index[card.name] = {
				card: card,
				activeQuantity: card.activeQuantity
			};
		});

		var deltas = [];
		to_deck.forEach(function(card) {
			if (from_deck_index[card.name].activeQuantity != card.activeQuantity) {
				if (Number.isNaN(card.activeQuantity)) {
					console.log('nan alert!', card);
				}

				deltas.push({
					/* card: from_deck_index[card.name].card, */
					card: card.name,
					quantity: card.activeQuantity || 0,
					delta: 
						Number(card.activeQuantity)
						- Number(from_deck_index[card.name].activeQuantity),
				});
			}
		});

		return deltas;
	};

	this.refresh = async function(cards, criteria, deck, format = 60) {
		return new Promise(resolve => {
			_t.changeApplicator = deck;
			this.status = 'Analyzing ... ';
			this.classList.remove('has-results');
			(new Pruner()).run(cards.map(card => ({
				...card,
	
				// default toJSON() hides relevant details which get stripped
				// when the card is seralized to be sent to the worker.
				toJSON: undefined
			})), criteria, format).and(function(result) {
				_t.targetRate = new SuccessRate({value: result.score.stabilityScore * 100});
				_t.suggestions = deckDelta(cards, result.deck).map(function(s) {
					// need to re-examine this, per updates to how `applyChanges` works.
					return new Suggestion({
						card: s.card,
						quantity: s.quantity,
						delta: s.delta,
						index: _t,
					});
				});
				if (_t.suggestions.length > 0) {
					_t.classList.add('has-results');
					_t.status = 'Complete.';
				} else {
					_t.status = "Nothing for you to do!";
				}
				resolve();
			});
		});
	};

	this.__dom.selectAll.onclick = () => {
		this.suggestions.forEach(s => {
			s.isSelected = this.__dom.selectAll.checked;
		})
	};

	this.__dom.applyChanges.onclick = function() {
		if (_t.changeApplicator.applyChanges) {
			_t.changeApplicator.applyChanges([
				..._t.suggestions
			].filter(c => c.isSelected));
			tracker.track('mtg_optimize_apply', {
				mtg_optimize_target: 'this_deck'
			});
		}
	};

	this.__dom.createNew.onclick = function() {
		if (_t.changeApplicator.createNew) {
			_t.changeApplicator.createNew([
				..._t.suggestions
			].filter(c => c.isSelected));
			tracker.track('mtg_optimize_apply', {
				mtg_optimize_target: 'new_deck'
			});
		}
	};

});
